module.exports = __webpack_public_path__ + "static/media/add category.e68c4b35.svg";